export const updateBeefProductBrands = (payload) => {
    return {
        type: 'beefProductBrands/update',
        payload
    }
}